import React from 'react';
import { batch } from 'react-redux';

import CarData from '../components/CompatibilityModal/components/CarData';
import { setCompatibilityList } from '../actions/vehicleCompatibility/vehicleCompatibilityList';
import getCompatibilityModelGroup, {
  setCompatibilityModelGroup
} from '../thunks/Compatibility/getCompatibilityModelGroup';
import getCompatibilityYearGroup, {
  setCompatibilityYearGroup
} from '../thunks/Compatibility/getCompatibilityYearGroup';
import getCompatibilityCarsGroup from '../thunks/Compatibility/getCompatibilityCarsGroup';

const prepareSelectedVehicleObject = (data) => ({
  makes: Object?.keys(data)
    ?.map((make) => ({
      label: make,
      value: make
    })) || [],
  model: Object?.keys(data)
    ?.map((make) => Object?.keys(data[make])
      ?.map((model) => ({
        label: `${make}: ${model}`,
        value: model,
        make,
      })))
    .reduce((acc, curr) => [...acc, ...curr], []),
  years: Object?.keys(data)
    .map((make) => Object?.keys(data[make])
      ?.map((model) => Object?.keys(data[make][model])
        ?.map((year) => ({
          label: `${model}: ${year}`,
          value: year,
          model,
          make
        })))
      .reduce((acc, curr) => [...acc, ...curr], []))
    .reduce((acc, curr) => [...acc, ...curr], []),
});

export const setCarNote = (obj, id, note) => Object.keys(obj)
  .map((make) => ({
    [make]: Object.keys(obj[make])
      .map((model) => ({
        [model]: Object.keys(obj[make][model])
          .map((year) => ({
            [year]: Object.keys(obj[make][model][year])
              .map((style) => ({
                [style]: Object.keys(obj[make][model][year][style])
                  .map((engine) => ({
                    [engine]: obj[make][model][year][style][engine].car_id === id ? {
                      ...obj[make][model][year][style][engine],
                      car_note: note
                    } : obj[make][model][year][style][engine]
                  }))
                  .reduce((prev, curr) => ({ ...prev, ...curr }), {})
              }))
              .reduce((prev, curr) => ({ ...prev, ...curr }), {})
          }))
          .reduce((prev, curr) => ({ ...prev, ...curr }), {})
      }))
      .reduce((prev, curr) => ({ ...prev, ...curr }), {})
  }))
  .reduce((prev, curr) => ({ ...prev, ...curr }), {});

export const prepareVehicleAccordionObject = (temp, setTemp) => Object.keys(temp)
  ?.map((make) => Object.keys(temp[make])
    ?.map((model) => Object.keys(temp[make][model])
      ?.map((year) => ({
          title: `${make} ${model} ${year} (${Object.keys(temp[make][model][year]).length})`,
          make,
          model,
          year,
          content: <CarData
            key={`${make} ${model} ${year}`}
            data={temp[make][model][year]}
            selectAll={() => {
              // selected
              let acc = temp;
              Object.keys(temp[make][model][year])
                ?.map((trim) => Object.keys(temp[make][model][year][trim])
                  // eslint-disable-next-line array-callback-return
                  ?.map((engine) => {
                    const { selected } = temp[make][model][year][trim][engine];
                    acc = {
                      ...acc,
                      [make]: {
                        ...acc[make],
                        [model]: {
                          ...acc[make][model],
                          [year]: {
                            ...acc[make][model][year],
                            [trim]: {
                              ...acc[make][model][year][trim],
                              [engine]: {
                                ...acc[make][model][year][trim][engine],
                                selected: !selected
                              }
                            }
                          }
                        }
                      }
                    };
                  }));
              setTemp(acc);
            }}
            onSelect={(data) => setTemp({
              ...temp,
              [make]: {
                ...temp[make],
                [model]: {
                  ...temp[make][model],
                  [year]: {
                    ...temp[make][model][year],
                    [data.trim]: {
                      ...temp[make][model][year][data.trim],
                      [data.engine]: {
                        ...temp[make][model][year][data.trim][data.engine],
                        ...data.info
                      }
                    }
                  }
                }
              }
            })}
            setCarNote={setCarNote}
          />
        }
      )))
    .reduce((acc, curr) => [...acc, ...curr], []))
  .reduce((acc, curr) => [...acc, ...curr], []);

export const getCarIds = (cars) => {
  const ids = [];
  Object.values(cars)
    .flatMap((make) => Object.values(make)
      .flatMap((model) => Object.values(model)
        .flatMap((year) => Object.values(year)
          .flatMap((trim) => Object.values(trim)
            .flatMap((engine) => engine.selected && ids.push({
              car_id: engine.car_id,
              note: engine.car_note
            }))))));
  return ids;
};

export const setMake = (value, {
  option,
  removedValue
}, vehicleCompatibilityList, modelGroup, dispatch) => {
  if (removedValue) {
    const {
      [removedValue.value]: _,
      ...tempMake
    } = vehicleCompatibilityList;
    dispatch(setCompatibilityList(tempMake));
    dispatch(setCompatibilityModelGroup(
      modelGroup?.filter(({ label }) => label !== removedValue.value)
    ));
  } else {
    const tempMake = value.reduce((acum, { value: val }) => {
      return {
        ...acum,
        [val]: (acum[val] ? ({ ...acum[val] }) : ({}))
      };
    }, vehicleCompatibilityList);
    batch(() => {
      dispatch(setCompatibilityList(tempMake));
      dispatch(getCompatibilityModelGroup({
        make: [option?.value]
      }));
    });
  }
};

export const setModel = (value, {
    option,
    removedValue
  },
  vehicleCompatibilityList,
  yearGroup,
  dispatch) => batch(() => {
  if (removedValue) {
    const temp = Object.keys(vehicleCompatibilityList[removedValue.make])
      .map((key) => {
        if (key !== removedValue.value) {
          return {
            [key]: vehicleCompatibilityList[removedValue.make][key]
          };
        }
        return {};
      })
      .reduce((acc, cur) => Object.assign(acc, cur), {});
    batch(() => {
      dispatch(setCompatibilityList({
        ...vehicleCompatibilityList,
        [removedValue.make]: temp
      }));
      dispatch(setCompatibilityYearGroup(
        yearGroup?.filter(({ label }) => `${label}` !== removedValue.value)
      ));
    });
  } else {
    batch(() => {
      dispatch(setCompatibilityList({
        ...vehicleCompatibilityList,
        [option?.make]: {
          ...vehicleCompatibilityList[option?.make],
          [option?.value]: {}
        }
      }));
      dispatch(getCompatibilityYearGroup({
        make: [option?.make],
        model: [option?.value]
      }));
    });
  }
});

export const setYear = (value,
  {
    option: {
      make,
      model,
      value: year
    } = {},
    removedValue
  },
  vehicleCompatibilityList, dispatch) => {
  if (removedValue) {
    const temp = Object.keys(vehicleCompatibilityList[removedValue.make][removedValue.model])
      .map((key) => {
        if (key !== removedValue.value) {
          return {
            [key]: vehicleCompatibilityList[removedValue.make][removedValue.model][key]
          };
        }
        return {};
      })
      .reduce((acc, cur) => Object.assign(acc, cur), {});
    dispatch(setCompatibilityList({
      ...vehicleCompatibilityList,
      [removedValue.make]: {
        ...vehicleCompatibilityList[removedValue.make],
        [removedValue.model]: temp
      }
    }));
  } else {
    const cars = {
      ...vehicleCompatibilityList,
      [make]: {
        ...vehicleCompatibilityList[make],
        [model]: {
          ...vehicleCompatibilityList[make][model],
          [year]: {}
        }
      }
    };
    batch(() => {
      dispatch(setCompatibilityList(cars));
      dispatch(getCompatibilityCarsGroup({
        [make]: {
          [model]: {
            [year]: {}
          }
        }
      }));
    });
  }
};

export default prepareSelectedVehicleObject;
